import React from "react";
import RenderFields from "./ModalFields/RenderFields";
import ModalAccordion from "./ModalAccordion";

const GenericInfoPanel = ({
  title,
  fieldSections,
  formData,
  isEditMode,
  newMode,
  onChange,
  onSubmit,
  onCancel,
}) => {
  return (
    <div className="p-4">
      <h2 className="pl-2 mb-4 font-bold text-sss-blue-sel border-gray-200 border bg-gray-200">
        {title}
      </h2>
      {fieldSections.map((section, index) => (
        <div key={index}>
          <ModalAccordion label={section.label}>
            <RenderFields
              fields={section.fields}
              formData={formData || {}}
              handleChange={onChange}
              readOnly={!isEditMode && !newMode}
              validationErrors={{}}
            />
          </ModalAccordion>
        </div>
      ))}
      <div className="mt-4">
        {newMode ? (
          <>
            <button
              onClick={onSubmit}
              className="px-4 py-2 bg-gray-700 text-white"
            >
              Submit
            </button>
            <button
              onClick={onCancel}
              className="px-4 py-2 bg-gray-300 text-white ml-2"
            >
              Cancel
            </button>
          </>
        ) : (
          isEditMode && (
            <button
              onClick={onSubmit}
              className="px-4 py-2 bg-gray-700 text-white"
            >
              Save
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default GenericInfoPanel;
